import { useEffect } from "react";

export const useOverlayControls = (onClose: () => void) => {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };

    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;

      // Ignore clicks inside overlay
      if (target.closest("[data-overlay]")) return;

      // Ignore chevron buttons
      if (target.closest("[data-overlay-trigger]")) return;

      onClose();
    };

    document.addEventListener("keydown", handleKey);
    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("keydown", handleKey);
      document.removeEventListener("mousedown", handleClick);
    };
  }, [onClose]);
};
